import React from 'react';
// Acupuncture needle — thin steel needle with colored handle
export const AcupunctureNeedle = ({
  className = '',
  color = '#B91C1C',
  style
}: {
  className?: string;
  color?: string;
  style?: React.CSSProperties;
}) => <svg viewBox="0 0 24 120" className={className} style={style} fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-id="element-378">
    {/* Coiled handle */}
    <rect x="9" y="4" width="6" height="32" rx="2" fill={color} data-id="element-379" />
    {[0, 1, 2, 3, 4, 5, 6, 7].map(i => <line key={i} x1="9" y1={6 + i * 4} x2="15" y2={6 + i * 4} stroke="rgba(255,255,255,0.45)" strokeWidth="0.8" data-id="element-380" />)}
    {/* Shaft */}
    <line x1="12" y1="36" x2="12" y2="112" stroke="#94A3B8" strokeWidth="1.4" strokeLinecap="round" data-id="element-381" />
    {/* Tip */}
    <line x1="12" y1="112" x2="12" y2="118" stroke="#475569" strokeWidth="1.6" strokeLinecap="round" data-id="element-382" />
  </svg>;
// Moxa stick — cylindrical herb stick with glowing ember tip
export const MoxaStick = ({
  className = '',
  style
}: {
  className?: string;
  style?: React.CSSProperties;
}) => <svg viewBox="0 0 32 120" className={className} style={style} fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-id="element-383">
    {/* Stick body */}
    <rect x="8" y="20" width="16" height="92" rx="2" fill="#FEF3C7" stroke="#D97706" strokeWidth="0.8" data-id="element-384" />
    {/* Wrapper texture lines */}
    {[0, 1, 2, 3, 4, 5, 6, 7, 8].map(i => <line key={i} x1="8" y1={28 + i * 10} x2="24" y2={28 + i * 10} stroke="#D97706" strokeOpacity="0.3" strokeWidth="0.5" data-id="element-385" />)}
    {/* Ember tip glow */}
    <ellipse cx="16" cy="20" rx="9" ry="7" fill="#F97316" opacity="0.35" className="animate-ember" data-id="element-386" />
    <ellipse cx="16" cy="20" rx="6" ry="4" fill="#DC2626" data-id="element-387" />
    <ellipse cx="16" cy="19" rx="3" ry="2" fill="#FCD34D" data-id="element-388" />
    {/* Smoke wisps */}
    <path d="M16 12 Q14 8 16 4 Q18 0 16 -4" stroke="#94A3B8" strokeOpacity="0.5" strokeWidth="1" fill="none" strokeLinecap="round" data-id="element-389" />
    <path d="M13 10 Q11 6 13 2" stroke="#94A3B8" strokeOpacity="0.3" strokeWidth="0.8" fill="none" strokeLinecap="round" data-id="element-390" />
  </svg>;
// Cupping glass — bell-shaped suction cup
export const CuppingGlass = ({
  className = '',
  style
}: {
  className?: string;
  style?: React.CSSProperties;
}) => <svg viewBox="0 0 60 60" className={className} style={style} fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-id="element-391">
    {/* Glass body */}
    <path d="M14 18 Q14 8 30 8 Q46 8 46 18 L46 44 Q46 50 30 50 Q14 50 14 44 Z" fill="rgba(254, 202, 202, 0.30)" stroke="#DC2626" strokeWidth="1.5" data-id="element-392" />
    {/* Rim highlight */}
    <ellipse cx="30" cy="10" rx="14" ry="3" fill="rgba(255,255,255,0.4)" data-id="element-393" />
    {/* Glass shine */}
    <path d="M20 16 Q19 26 20 38" stroke="rgba(255,255,255,0.6)" strokeWidth="2" strokeLinecap="round" fill="none" data-id="element-394" />
    {/* Base rim */}
    <ellipse cx="30" cy="48" rx="16" ry="3" fill="#991B1B" opacity="0.7" data-id="element-395" />
  </svg>;
// Yin-Yang symbol
export const YinYang = ({
  className = '',
  style
}: {
  className?: string;
  style?: React.CSSProperties;
}) => <svg viewBox="0 0 100 100" className={className} style={style} xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-id="element-396">
    <circle cx="50" cy="50" r="48" fill="#fff" stroke="#B91C1C" strokeWidth="2" data-id="element-397" />
    <path d="M50 2 a48 48 0 0 1 0 96 a24 24 0 0 1 0 -48 a24 24 0 0 0 0 -48 z" fill="#B91C1C" data-id="element-398" />
    <circle cx="50" cy="26" r="6" fill="#fff" data-id="element-399" />
    <circle cx="50" cy="74" r="6" fill="#B91C1C" data-id="element-400" />
  </svg>;
// Decorative scattered icon group - to be placed in background of sections
export const TCMBackgroundDecor = ({
  className = ''
}: {
  className?: string;
}) => <div className={`absolute inset-0 pointer-events-none overflow-hidden -z-10 ${className}`} aria-hidden="true" data-id="element-401">
    <AcupunctureNeedle className="absolute top-10 left-[5%] w-4 h-20 opacity-15 animate-float-soft" color="#B91C1C" style={{
    ['--rot' as any]: '15deg',
    transform: 'rotate(15deg)'
  }} data-id="element-402" />
    <AcupunctureNeedle className="absolute top-40 right-[8%] w-4 h-20 opacity-15 animate-float-soft" color="#DC2626" style={{
    ['--rot' as any]: '-25deg',
    transform: 'rotate(-25deg)',
    animationDelay: '1s'
  }} data-id="element-403" />
    <CuppingGlass className="absolute bottom-20 left-[8%] w-14 h-14 opacity-20 animate-float-soft" style={{
    animationDelay: '2s'
  }} data-id="element-404" />
    <MoxaStick className="absolute bottom-32 right-[6%] w-6 h-24 opacity-25 animate-float-soft" style={{
    ['--rot' as any]: '20deg',
    transform: 'rotate(20deg)',
    animationDelay: '0.5s'
  }} data-id="element-405" />
  </div>;